import React from 'react'
import { StepIndicatorProps } from './types'
import './Scss/step-indicator.scss';

const StepIndicator = (props: StepIndicatorProps) => {
    const innerDotWidth = 0.5625
    const outerDotWidth = 0.9375
    const separatorWidth = 1.875
    const leftPadding = (outerDotWidth - innerDotWidth) / 2
    const width = props.count * innerDotWidth + (props.count - 1) * 1.875 + leftPadding
    const left = (props.step - 1) * (innerDotWidth + separatorWidth)
    const display = props.step > props.count || props.step < 1 ? 'none' : 'block'
    
    const renderStepDots = () => {
        const total = []
        for (let i = 0; i < props.count; i++) {
            const activeClass = props.step === i + 1 ? 'active' : ''
            const inRangeClass = props.step > i + 1 ? 'in-range' : ''
            const anchored = props.anchoredElements && props.anchoredElements[i]
            total.push(
                <div className={`step-dot ${activeClass} ${inRangeClass}`}
                     key={`step-dot-${props.count}-${i}`}
                >
                    <div className={`inner-dot ${activeClass} ${inRangeClass}`}>
                        {anchored && (
                            <div className={'inner-dot__anchored-element'}>
                                {anchored}
                            </div>
                        )}
                    </div>
                </div>
            )
            if (i < props.count - 1) {
                total.push(
                    <div
                        className={`step-separator ${inRangeClass}`}
                        key={`step-separator-${props.count}-${i}`}
                    />
                )
            }
        }
        return total
    }

    return (
        <div className={`step-indicator ${props.className ?? ''}`} style={{'--step-indicator-width': width + 'rem'} as React.CSSProperties }>
            {renderStepDots()}
            <div className={'step-indicator__outer-dot'} style={{'--outerDotLeft': left + 'rem', display: `${display}`} as React.CSSProperties }></div>
        </div>
    )
}

export default StepIndicator
